import { DateTime } from 'luxon';
import { isNullOrEmpty } from '../../core/utils/common-functions';

export namespace DateUtils {
  /**
   * Get today date object from now.
   *
   * @export
   * @return {*}  {Date}
   */
  export function today(): Date {
    return DateTime.now().startOf('day').toJSDate();
  }

  export function calculateAge(birthdate: Date): number | null {
    // 检查日期是否有效
    if (isNaN(birthdate.getTime())) {
      console.error('Invalid date');
      return null;
    }
    const currentDate = new Date();
    let age = currentDate.getFullYear() - birthdate.getFullYear();

    // 生日還沒到減一
    if (
      currentDate.getMonth() < birthdate.getMonth() ||
      (currentDate.getMonth() === birthdate.getMonth() &&
        currentDate.getDate() < birthdate.getDate())
    ) {
      age--;
    }

    return age;
  }

  /** without timezone */
  export function convertTimezoneToUtc(date: Date, reverse: boolean): Date {
    if (isNullOrEmpty(date)) {
      return date;
    }
    const localDate = new Date(date.getTime());
    localDate.setMinutes(localDate.getMinutes());
    return localDate;
  }
}
